/* eslint-disable quotes */
import ConfidenceLevel from "@/constants/ConfidenceLevel";

export default {
	TextEditor_returnLabel: "<strong>Return</strong> to save",
	TextEditor_shirtReturnLabel: "<strong>Shift + Return</strong> to add a new line",

	MarkdownEditor_markdownSupportedLabel: `<strong><a href="https://www.markdownguide.org/cheat-sheet/" target="_blank">Basic Markdown</a></strong> supported`,

	//
	// ConfidenceChip
	//
	[ `ConfidenceChip_${ ConfidenceLevel.LOW }Label` ]: "Low",
	[ `ConfidenceChip_${ ConfidenceLevel.MEDIUM }Label` ]: "Medium",
	[ `ConfidenceChip_${ ConfidenceLevel.HIGH }Label` ]: "High",

	TrialEndDialog_title: "Trial Period Ended",
	TrialEndDialog_bodyHTML: [
		`<p>Your 14-day trial of Teaming has ended. Subscribe for only $7 per user, per month to continue. If you’re not responsible for payments, please let your team lead know it’s time to subscribe.</p>`,
		`<p>If you and your team have questions, or need more time to evaluate Teaming, `,
		`<a href="#" data-action="trialEndDialog/schedule">schedule a time</a> to talk or <a href="#" data-action="trialEndDialog/chat">chat with us now</a>.</p>`,
	].join( "" ),
	TrialEndDialog_subscribeNowButton: "Subscribe now",
};



// WEBPACK FOOTER //
// ./src/lang/en/common.js